import images from './images';
import resume from '../assets/Sharad_Tembhurne_Resume.pdf';
import swarmRobots from '../assets/swarmRobots.pdf';
import kpitInd from '../assets/kpitInd.png';
import kpitUS from '../assets/kpitUS.jpg'
import mit from '../assets/mit.jpg'
import nyu from '../assets/nyu.png'



const wines = [
  {
    title: 'Senior Software Engineer',
    date: 'June 2023 - Present',
    company_name: 'KPIT Technologies',
    location: 'Novi, Michigan',
    points: [
      'Developed Python automation suite leveraging TestRail APIs, by utilizing AI-assisted development tools to update testcase data for 4,800+ test cases and reduced update time from 30 hours to under 10 minutes.',
      'Automated a manual, repetitive workflow via Python (PyWinAuto, PyAutoGUI) to drive a legacy internal tool with no exposed APIs, cutting a routine 20–30 minute task to under 5 minutes (80-85% reduction)',
      'Designed and built an internal AI agent that analyzes test plans and recommends optimal test executionsequencing, reducing test cycle time by an average of 20% (ranging 12–33%) across varying plan sizes.',
      'Built a Java application to communicate with locally hosted non-Java services by developing Python API wrappers and using socket programming to enable reliable cross-language, on-system data exchange.',
      'Re-architected the core codebase and APIs of ECU Validator, an internal automotive test-execution tool, using Java and Angular to extend support from UDS to the J1939 protocol, enabling a second major automotive communication standard and securing over $480K in annual revenue.',
      'Conducted in-vehicle testing to validate Over-The-Air (OTA) software update correctness and bug fixes across release cycles, achieving a 100% on time delivery.'
    ],
      
    icon: kpitInd,
    company_website: 'https://www.kpit.com/around_the_world/kpit-in-us/'
  },
  {
    // title: 'Software Engineer',
    date: 'September 2022 - December 2023',
    company_name: 'New York University',
    location: 'New York City',
    points: [
      'Won a scholarship of $8000 per year to pursue Master\'s degree due to a strong academic and professional background, demonstrating exceptional merit and potential in the field.',
      'Relevant Coursework: Data Structure and Algorithms, Machine Learning, Deep Learning, Big Data, Internet Architecture and Protocols'
    ],
      icon: nyu,
      company_website: 'https://engineering.nyu.edu/'
  },
  {
    title: 'Software Engineer',
    date: 'November 2019 - July 2022',
    company_name: 'KPIT Technologies India',
    location: 'Pune, India',
    points: [
      'Developed entire OTX (Open Test Sequence eXchange) script test suite for multiple clients adhering to ISO 13209. The scripts were designed to test the Body, Powertrain, Chassis, and Network Control Modules.',
      'Leveraged Java to to automate the process of generating OTX scripts so that similar tests can be used for multiple clients without compromising code quality and ensuring all edge cases and boundary conditions.',
      'Authored ODX (Open Diagnostic Data Exchange) data with respect to Unified Diagnostic Services (UDS) and On-Board Diagnostic (OBD) protocols to execute OTX test scripts.',
      'Developed React components from scratch with minimal software requirement specifications. This involved a high degree of creativity as it required interpreting vague requirements into functional React components.'
    ],
      icon: kpitUS,
      company_website: 'https://www.kpit.com/'
  },
  {
    // title: 'Software Engineer',
    date: 'July 2015 - May 2019',
    company_name: 'Maharashtra Institute of Technology, Pune',
    location: 'Pune, India',
    points: [
      'Vice Chairman of MIT IEEE Student Branch',
      'Vice President of MIT Association of Recreation and Sports'
    ],
      icon: mit,
      company_website: 'https://mitwpu.edu.in/'
  },
];

const projects = [
  {
    title: 'Personal Portfolio',
    link: 'https://github.com/sharadTT/sharadTT.github.io',
    img : images.personalPortfolioImg,
    tags: ['React','CSS','HTML','JavaScript','UX Design'],
    description: 'You are currently visiting this website, which has been meticulously crafted using the power of React and CSS. This combination not only guarantees mobile responsiveness but also showcases the modularity of React components.'
  },

  {
    title: 'Doraemon Gadget Catalog',
    link: 'https://sharadtt.github.io/doraemon-gadgets/',
    img : images.dorarmonGadgetImg,
    tags: ['HTML','CSS','JavaScript'],
    description: 'This catalog developed using HTML, CSS, and Javascript implements infinte scrolling which is generally used to dynamically load the webpage as the used scrolls down. This is generally used in shopping websites.'
  },

  {
    title: 'Chess Insights',
    link: 'https://github.com/sharadTT/chess',
    img : images.chessInsightsImg,
    tags: ['Python','MongoDB','Docker','Flask','API','HTML','CSS','JavaScript'],
    description: 'Developed using Python, MongoDB, Docker, Flask, HTML, CSS, JavaScript, and APIs from chess.com, this is a light weight app which helps visualize chess games move by move and provide player insights for each player in the database.',
  },

  {
    title: 'Personal Portfolio v1',
    link: 'https://sharadtt.github.io/personal-portfolio-v1',
    img : images.personalPortfoliov1Img,
    tags: ['HTML','CSS','JavaScript'],
    description: 'This is the first iteration of my portfolio which was developed using HTML, CSS, and Javascript.'
  },

  {
    title: 'Swarm Robots',
    link: swarmRobots,
    img : images.swarmRobotsImg,
    tags: ['C','Arduino','AtMega328P','Circuit Design','Hardware'],
    description: 'This project focused on designing and developing 5 slave robots and 1 master robot using ATMega328P chip and arduino programs to showcase a swarm behaviour which could be easily scaled up.'
  },
];

const colleges = [
  {
    universityName: 'New York University',
    collegeName: 'Tandon School of Engineering',
    degree: 'Master of Science',
    course: 'Computer Engineering',
    duration: 'September 2022 - December 2023',
    universityWebsite: 'https://www.nyu.edu/',
    collegeWebsite: 'https://engineering.nyu.edu/',
  },
  {
    universityName: 'Savitribai Phule Pune University',
    collegeName: 'Maharashtra Institute of Technology, Pune',
    degree: 'Bachelor\'s of Engineering',
    course: 'Electronics and Telecommunication',
    duration: 'July 2015 - May 2019',
    universityWebsite: 'https://mitwpu.edu.in/',
    collegeWebsite: 'https://mitwpu.edu.in/schools/faculty-of-engineering-and-technology/school-of-engineering-and-technology',
  },
];

const technologies = [
  {
    technology: 'Python',
    image: images.python,
    link: 'https://www.python.org/',
  },
  {
    technology: 'Java',
    image: images.java,
    link: 'https://www.java.com/en/',
  },
  {
    technology: 'Cursor',
    image: images.cursor,
    link: 'https://cursor.com/',
  },
  {
    technology: 'Copilot',
    image: images.copilot,
    link: 'https://copilot.github.com/',
  },
  {
    technology: 'TypeScript',
    image: images.typescript,
    link: 'https://www.typescriptlang.org/',
  },
  {
    technology: 'Linux',
    image: images.linux,
    link: 'https://www.linux.org/',
  },
  
  {
    technology: 'React',
    image: images.react,
    link: 'https://react.dev/',
  },
  {
    technology: 'JavaScript',
    image: images.javascript,
    link: 'https://www.javascript.com/',
  },
  {
    technology: 'HTML',
    image: images.html,
    link: 'https://www.google.com/search?q=html',
  },
  {
    technology: 'CSS',
    image: images.css,
    link: 'https://www.google.com/search?q=css',
  },
  {
    technology: 'Flask',
    image: images.flask,
    link: 'https://flask.palletsprojects.com/en/3.0.x/'
  },
  {
    technology: 'MongoDB',
    image: images.mongo,
    link: 'https://www.mongodb.com/',
  },
  {
    technology: 'SQL',
    image: images.sql,
    link: 'https://www.sql.com/',
  },
  {
    technology: 'PostgreSQL',
    image: images.postgresql,
    link: 'https://www.postgresql.org/',
  },
  {
    technology: 'AWS',
    image: images.aws,
    link: 'https://aws.amazon.com/',
  },
  {
    technology: 'Maven',
    image: images.maven,
    link: 'https://maven.apache.org/',
  },
  {
    technology: 'Selenium',
    image: images.selenium,
    link: 'https://www.selenium.dev/',
  },
  {
    technology: 'Postman',
    image: images.postman,
    link: 'https://www.postman.com/',
  },
  {
    technology: 'Jenkins',
    image: images.jenkins,
    link: 'https://www.jenkins.io/',
  },
  {
    technology: 'Docker',
    image: images.docker,
    link: 'https://www.docker.com/',
  },
  {
    technology: 'Figma',
    image: images.figma,
    link: 'https://www.figma.com/'
  },
  {
    technology: 'Git',
    image: images.git,
    link: 'https://git-scm.com/',
  },
  {
    technology: 'JIRA',
    image: images.jira,
    link: 'https://www.atlassian.com/software/jira',
  },
  {
    technology: 'Spark',
    image: images.spark,
    link: 'https://spark.apache.org/',
  },
  {
    technology: 'OTX',
    image: images.otxstudio,
    link: 'https://automotive.softing.com/products/softing-dts/softing-otxstudio.html',
  },
  {
    technology: 'CANoe ',
    image: images.canoe,
    link: 'https://www.vector.com/us/en/products/products-a-z/software/canoe/',
  },
  


  //HTML, CSS, JavaScript, OTX, C/C++, Flask, React, MongoDB, SQL, PostgreSQL, Docker, Figma, Git, JIRA, Spark, CANoe, OTX Studio, Raspberry Pi

];


export default { wines, colleges, projects, resume, technologies };
